import { render, staticRenderFns } from "./naoVisualizadosRetiradosNaoRetirados.vue?vue&type=template&id=04ad2b5e"
import script from "./naoVisualizadosRetiradosNaoRetirados.vue?vue&type=script&lang=js"
export * from "./naoVisualizadosRetiradosNaoRetirados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports